var _style, _circle, _path, _path2, _circle2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconoIg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 294.05 294.05",
    style: {
      enableBackground: "new 0 0 294.05 294.05"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFC303;}\n\t.st1{fill:#1A1A1A;}\n")), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 147.02,
    cy: 147.02,
    r: 147.02
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M188.55,36.27h-83.06C71.7,36.31,44.31,63.7,44.27,97.49v83.06c0.04,33.79,27.43,61.18,61.22,61.22h83.06 c33.79-0.04,61.18-27.43,61.22-61.22V97.49C249.73,63.7,222.34,36.31,188.55,36.27z M229.1,180.55 c0.01,22.39-18.14,40.54-40.53,40.55c-0.01,0-0.01,0-0.02,0h-83.06c-22.39,0.01-40.54-18.14-40.55-40.53c0-0.01,0-0.01,0-0.02V97.49 c-0.01-22.39,18.14-40.54,40.53-40.55c0.01,0,0.01,0,0.02,0h83.06c22.39-0.01,40.54,18.14,40.55,40.53c0,0.01,0,0.01,0,0.02V180.55z "
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M147.02,85.87c-29.35,0-53.15,23.8-53.15,53.15s23.8,53.15,53.15,53.15s53.15-23.8,53.15-53.15l0,0 C200.14,109.68,176.36,85.9,147.02,85.87z M147.02,171.5c-17.94,0-32.48-14.54-32.48-32.48s14.54-32.48,32.48-32.48 s32.48,14.54,32.48,32.48l0,0C179.5,156.96,164.96,171.5,147.02,171.5z"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 200.28,
    cy: 86.27,
    r: 12.74
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconoIg);
export default __webpack_public_path__ + "static/media/iconoIG.674f668e62687e0a0faf64ac82a15814.svg";
export { ForwardRef as ReactComponent };